// extracted by mini-css-extract-plugin
export var addButton = "_50-d";
export var bullets = "_50-e";
export var compact = "_50-2";
export var container = "_50-j";
export var extendedWarrantyModal = "_50-f";
export var learn = "_50-l";
export var learnMore = "_50-g";
export var offeringOption = "_50-3";
export var offeringPrice = "_50-8";
export var offeringSubtitle = "_50-7";
export var offeringTitle = "_50-6";
export var offeringsContainer = "_50-0";
export var pdpTilesBackground = "_50-n";
export var plan = "_50-m";
export var regular = "_50-1";
export var remove = "_50-k";
export var seeDetailsIcon = "_50-i";
export var seeDetailsLink = "_50-h";
export var selectedOption = "_50-4";
export var shieldIcon = "_50-b";
export var shieldIconCompact = "_50-c";
export var subtitle = "_50-a";
export var title = "_50-9";
export var unselectedOption = "_50-5";